import axios from "axios";
import ApiUrls from "@/service/ApiUrls";

export default axios.create({
  baseURL:  ApiUrls.baseURL, // `https://edu-api.cast-soft.com/api`, // `http://admin.cast.local/api`, `https://edu-admin.not4prod.com/api`, //, // `http://portal.ubuntu.shalmanzer.local/api`, `https://edu-admin.not4prod.com/api`,
  headers: {
      'Authorization': `Bearer ${localStorage.token}`
  }
});
